// store
import { dispatch } from '../setup/redux'
// actions
import { queueRemoveUnsaved } from '../logic/queue/queue.action'

export default () => dispatch(queueRemoveUnsaved())
